import StatusType from "enums/CardStatusType";
import CardType from "enums/CardType";

/**
 * When each card action is possible at all, by card state. Routes layer their
 * own role gates on top; neither one restates these.
 */

/** ACTIVE edits the policy; PENDING and ISSUED amend the request behind it. */
export const canEditCard = (status?: string | null): boolean =>
  status === StatusType.ACTIVE ||
  status === StatusType.ISSUED ||
  status === StatusType.PENDING;

// An external card is a feed we import, so there is nothing to cancel; freezing one stops the import.
export const canCancelCard = (
  status?: string | null,
  type?: string | null,
): boolean =>
  type !== CardType.EXTERNAL &&
  (status === StatusType.ACTIVE ||
    status === StatusType.FROZEN ||
    status === StatusType.ISSUED ||
    status === StatusType.PENDING);

export const canFreezeCard = (status?: string | null): boolean =>
  status === StatusType.ACTIVE || status === StatusType.FROZEN;
